module.exports = __webpack_public_path__ + "img/inactivar_tx.4639f3a8.svg";